// utils/versionCheck.js
import { ref } from 'vue'
import { checkVersionAuto, setSocialOn } from '@/api/appVersion'
import { Capacitor } from '@capacitor/core'

/**
 * 版本检测状态
 */
export const versionCheckState = ref({
  showUpdateDialog: false,
  versionInfo: null,
  currentVersion: '',
  hasChecked: false, // 是否已经检测过
  isForceUpdate: false // 是否是强制更新
})

/**
 * 检查APP版本更新
 * @param {string} appType - 端类型：customer-客户端, manage-管理版
 * @param {boolean} forceCheck - 是否强制检测（忽略已检测状态）
 */
export const checkAppVersion = async (appType = 'aroma', forceCheck = false) => {
  console.log('🔍 checkAppVersion 被调用 - appType:', appType, 'forceCheck:', forceCheck)
  console.log('🔍 Capacitor.isNativePlatform():', Capacitor.isNativePlatform())
  console.log('🔍 Capacitor.getPlatform():', Capacitor.getPlatform())
  console.log('🔍 当前状态 - hasChecked:', versionCheckState.value.hasChecked, 'isForceUpdate:', versionCheckState.value.isForceUpdate, 'showUpdateDialog:', versionCheckState.value.showUpdateDialog)

  // 如果是强制更新，需要一直检查并显示弹窗
  if (versionCheckState.value.isForceUpdate) {
    console.log('⚠️ 强制更新模式，确保弹窗显示')
    if (!versionCheckState.value.showUpdateDialog && versionCheckState.value.versionInfo) {
      console.log('🔄 重新显示强制更新弹窗')
      versionCheckState.value.showUpdateDialog = true
    }
    return
  }

  // 如果已经检测过且不强制检测，则跳过
  if (versionCheckState.value.hasChecked && !forceCheck) {
    console.log('⏭️ 已检测过，跳过')
    return
  }

  // 只在原生平台检测
  if (!Capacitor.isNativePlatform()) {
    console.log('🌐 非原生平台，跳过版本检测')
    return
  }

  try {
    console.log('🔄 开始检测版本更新...')
    console.log('🔄 appType:', appType)

    const result = await checkVersionAuto(appType)
    console.log('📦 版本检测结果：', result)

    // API 直接返回数据，不是 { code, data } 结构
    const versionData = result?.data || result
    console.log('📦 versionData:', versionData)

    if (versionData) {
      const { hasUpdate, isForce, version, socialOn } = versionData

      // 保存社交功能开关配置（仅 Android 有效，iOS 忽略）
      if (typeof socialOn === 'boolean') {
        setSocialOn(socialOn)
        console.log('🔧 社交功能开关:', socialOn)
      }

      console.log('✅ hasUpdate:', hasUpdate, 'isForce:', isForce, 'version:', version)

      if (hasUpdate) {
        versionCheckState.value.versionInfo = versionData
        versionCheckState.value.showUpdateDialog = true

        // 如果是强制更新，记录状态
        if (isForce === 1) {
          versionCheckState.value.isForceUpdate = true
          console.log('⚠️ 强制更新，标记状态')
        }

        console.log('🎉 有新版本，显示更新弹窗')
        console.log('🎉 showUpdateDialog:', versionCheckState.value.showUpdateDialog)
      } else {
        console.log('✅ 已是最新版本')
      }

      versionCheckState.value.hasChecked = true
    } else {
      console.log('⚠️ 响应数据为空:', result)
    }
  } catch (error) {
    console.error('❌ 版本检测失败：', error)
    console.error('❌ 错误详情:', error.message, error.stack)
    // 检测失败不影响正常使用
  }
}

/**
 * 重置检测状态（用于重新检测）
 */
export const resetVersionCheck = () => {
  versionCheckState.value.hasChecked = false
}

/**
 * 关闭更新弹窗（仅非强制更新可关闭）
 */
export const closeUpdateDialog = () => {
  // 强制更新不允许关闭
  if (versionCheckState.value.versionInfo?.isForce === 1) {
    return false
  }
  versionCheckState.value.showUpdateDialog = false
  return true
}
